export default "__VITE_PUBLIC_ASSET__9fb136af__"